import { Keyword } from "../types/threatCoach";

export const highlightKeywordsInInnerHtml = (
  innerHtml: string,
  keywords: Keyword[],
) => {
  keywords.forEach((keyword) => {
    const highlightedText = `<span class='keyword keyword--${keyword.colorClass}'>${keyword.text} <span class='keyword__tag'>${keyword.tag}</span></span>`;

    innerHtml = innerHtml.replaceAll(keyword.text, highlightedText);
  });

  return innerHtml;
};
